import { useEffect, useState } from 'react';

function useScrollTrigger({ target, threshold = 100 }) {
    const [trigger, setTrigger] = useState(false);

    useEffect(() => {
        const element = target || window;

        const handleScroll = () => {
            const scrollPosition = element === window ? window.scrollY : element.scrollTop;

            setTrigger(scrollPosition > threshold);
        };

        if (element) {
            element.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (element) {
                element.removeEventListener('scroll', handleScroll);
            }
        };
    }, [target, threshold]);

    return trigger;
}

export default useScrollTrigger;
